import { HttpRequest, HttpHandlerFn, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { HttpCacheService } from '../../services/http-cache/http-cache.service';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

/**
 * Interceptor for caching HTTP requests
 * @param {HttpRequest<any>} req
 * @param {HttpHandlerFn} next
 * @return {*}  {Observable<HttpEvent<any>>}
 */
export const httpInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const cacheService = inject(HttpCacheService);
  // Only cache GET requests
  if (req.method !== 'GET') {
    if (req.method == 'POST') {
      cacheService.invalidateCache();
    }
    console.log("server call", req.method, req.urlWithParams)
    return next(req);
  }
  // Use the cache service to fetch with cache logic  
  if (req.url.includes(environment.API_LOCATION) && !req.url.includes("/api/user")) {
    return cacheService.fetchWithCache(req.urlWithParams, () => { console.log("server call", req.method, req.urlWithParams); return next(req) });
  } else {
    console.log("server call", req.method, req.urlWithParams)
    return next(req);
  }
};
